/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.p, null, "On April 22nd, the Board of Regents approved the Master of Digital Media Arts & Engineering Program at LSU.  This is the first program of its kind in the state and joins the ranks of over 40 succesful programs around the country."), "\n", React.createElement("span", {
    class: "lead"
  }, "\"The digital age is bringing in large systemic changes and digital media arts is at the forefront of this revolution.\" - Marc Aubanel"), "\n", React.createElement(_components.p, null, "his was a culmative effort that begun in 2011 when a delegation was sent to visit FIEA in Florida, ETC at Carnegie Mellon and USC's Interactive Media program.  Marc Aubanel was brought on in 2013 as its founding director when the curriculum development process began."));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
